import { Component, OnInit } from '@angular/core';
import { SlideInOutAnimation } from '../../animations';
import { TitleWrapperService } from '../_services/title-wrapper.service';

@Component({
  selector: 'app-marketing-landing',
  templateUrl: './marketing-landing.component.html',
  styleUrls: ['./marketing-landing.component.scss'],
  animations: [SlideInOutAnimation]
})
export class MarketingLandingComponent implements OnInit {

  active: boolean
  activeFaq: string

  constructor(private titleService: TitleWrapperService) { }
  toggleShowDiv(id: string) {
    this.activeFaq = id
    // this.active === true

  }

  ngOnInit(): void {
    this.titleService.SetTitle('Pricing for Massage Therapy Courses | ABMP CE Pricing', true);
  }

}
